import { useState } from "react";
import { List, Popover, Tooltip } from "antd";
import Icon from "@assets/icon_config";
import { useNavigate } from "react-router-dom";
import dashboardService from "@services/dashboard.service";
import { useMeasuresStore } from "@stores/measuresStore";
import { routeMap } from "@utils/constants";
import { Spinner } from "@components/healthemSpinner/healthemSpinner";

const ColumnContentRenderer = ({ value, formatTypes, record, column, selectedYear }: any) => {
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const patientIdsHandler = useMeasuresStore((state) => state.patientIdsHandler);
  const memberPageNavigationHandler = useMeasuresStore((state) => state.memberPageNavigationHandler);
  const appliedProvider = useMeasuresStore((state) => state.appliedProvider);
  const setMeasureName = useMeasuresStore((state) => state.setMeasureName);
  const setComingFromMeasuresReport = useMeasuresStore((state) => state.setComingFromMeasuresReport);
  const navigate = useNavigate();

  const fetchPatientIDs = (measureId: any, measureName: string, year: any, countType?: any) => {
    setShowLoader(true);
    dashboardService.fetchMemberListFromMeasures([measureId], appliedProvider[0], appliedProvider[1], appliedProvider[2], year, countType).subscribe({
      next: (v) => {
        patientIdsHandler(v.data.data.patientIds);
        setMeasureName(measureName);
        memberPageNavigationHandler(true);
        setComingFromMeasuresReport(true);
        setShowLoader(true);
        navigate(routeMap["members"]);
      },
      error: (e) => {
        setShowLoader(false);
      }
    });
  };

  if (formatTypes.includes("DESCRIPTION")) {
    const prefix = record?.lower_percentage_flag === "true" ? <span className="measure-report__body__required-star">*</span> : "";
    return (
      <div className="measure-report__body__table">
        <div className="measure-report__body__table__content">
          <span style={{ marginRight: "0.5rem" }}>{value}</span>
          {prefix}
          <Tooltip
            overlayStyle={{ maxWidth: "500px" }}
            title={
              record.measure_name_description && (
                <>
                  <span className="f16">{record?.measure_name_description}</span>
                  <br />
                  {formatTypes.includes("SUBDESCRIPTION") && <span>Domain: {record?.measure_name_subdescription}</span>}
                </>
              )
            }
          >
            <span className="pointer">
              <Icon name="info" colorOfBrand="#7A869A" height={"16"} width={"16"} />
            </span>
          </Tooltip>
        </div>
      </div>
    );
  }

  if (formatTypes.includes("LINK")) {
    if (value > 0) {
      if (record?.withoutProcedureCode || record?.withProcedureCode) {
        return (
          <Spinner loading={showLoader}>
            <div className="measure-report__body__table__content">
              <span className="f16 w500 clr-blueLink">{value.toLocaleString()}</span>
              <Popover
                content={
                  <List
                    dataSource={[
                      { count: record.withoutProcedureCode, description: "Patients with incomplete results or no test performed", countType: "withoutProcedureCode" },
                      { count: record.withProcedureCode, description: "Patients with Procedure Codes", countType: "withProcedureCode" },
                    ].filter((item) => item.count)}
                    renderItem={(item) => (
                      <List.Item>
                        <div>
                          <span className="f16 w500 clr-blueLink pointer" onClick={() => fetchPatientIDs(record.quality_measure_id, record.measure_name, selectedYear, item.countType)}>
                            {item.count}
                            <i className="icon icon-external-link ml-05"></i>
                          </span>
                          <div>{item.description}</div>
                        </div>
                      </List.Item>
                    )}
                  />
                }
                trigger="click"
                overlayStyle={{ maxWidth: 250 }}
              >
                <span className="pointer ml-05">
                  <Icon name="info" colorOfBrand="#7A869A" height={"16"} width={"16"} />
                </span>
              </Popover>
            </div>
          </Spinner>
        );
      } else {
        return (
          <Spinner loading={showLoader} size={20}>
            <span className="f16 w500 clr-blueLink pointer" onClick={() => fetchPatientIDs(record.quality_measure_id, record.measure_name, selectedYear)}>
              {value.toLocaleString()}
            </span>
          </Spinner>
        );
      }
    } else {
      return <span className="f16 w500">{value}</span>;
    }
  }

  if (formatTypes.includes("PERCENTAGE")) {
    return <span>{value}%</span>;
  }

  if (column && (column.dataIndex === "numerator" || column.dataIndex === "denominator")) {
    return <span>{value.toLocaleString()}</span>;
  }

  return <span>{value}</span>;
};

export default ColumnContentRenderer;
